import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { TableDefault, Breadcrumb, Tabs } from '../../../../components';


class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      page: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Descricao',
      order: '',
      urlDelete: '/ModeloCategoria/Delete',      
      urlLoad:  'ModeloCategoria/GetListagem/',
    };
  }

  create = () => {
    const {location, history} = this.props;
    console.log("create history", history);
    const urlCreate = location.pathname === "/admin/modelos-mensagem/categorias/mensagem" ? "/admin/modelos-mensagem/categoria/mensagem/criar" : "/admin/modelos-mensagem/categoria/sac/criar"
    history.push(urlCreate)
  };

  render() {
    const {
      page,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlLoad,    
    } = this.state;
    const {match} = this.props;
    return (
      <div>
        <Breadcrumb
          title="Categorias de modelos de mensagem"
          description="Gerencie categorias de modelos de mensagem."
          renderRight={(() => (
            <div className="flex v-sm-margin">
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.create()}
              >
                Criar Categoria
              </button>
            </div>
          ))()}
        />

        <section className="content-wrapper">
          <Tabs
            sections={[
              { title: 'Mensagens', path: `${match.url}/mensagem` },
              { title: 'SAC', path: `${match.url}/sac` }
            ]}
          />
          <Route
            path={`${match.url}/mensagem`}
            component={() => (
              <TableDefault
                search={search}
                type={1}
                order={order}
                orderBy={orderBy}
                page={page}
                pageSize={pageSize}
                totalItems={totalItems}
                urlDelete={urlDelete}
                urlEdit="/admin/modelos-mensagem/categoria/mensagem/editar/"
                urlLoad={urlLoad}
                deleteMessage="Esta ação removerá todos os modelos vinculados a esta categoria. Você tem certeza que deseja deletar este item?"
                onRef={ref => (this.tableList = ref)}
              />
            )}
          /> 
          <Route
            path={`${match.url}/sac`}
            component={() => (
              <TableDefault
                search={search}
                type={2}
                order={order}
                orderBy={orderBy}
                page={page}
                pageSize={pageSize}
                totalItems={totalItems}
                urlDelete={urlDelete}
                urlEdit="/admin/modelos-mensagem/categoria/sac/editar/"
                urlLoad={urlLoad}
                deleteMessage="Esta ação removerá todos os modelos vinculados a esta categoria. Você tem certeza que deseja deletar este item?"
                onRef={ref => (this.tableList = ref)}
              />
            )}
          />                    

        </section>
      </div>
    );
  }
}
export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/MessageModels/CategorysMessageModels/List.js